import { CHARACTER_COPY_DESTINATION_TYPE } from "constant/character/character_copy.constant";

export function newTopicCheck(copyType: string): boolean {
  const result: boolean =
    copyType === CHARACTER_COPY_DESTINATION_TYPE.TOPIC_NEW.value;

  return result;
}
